export default "__VITE_ASSET__DSY0cz2w__"